export const cliConfig = {
    'HOSTNAME': 'arcphysx.com',
    'USERNAME': 'guest',
    'INTRO': `
        Welcome to My Personal Website!<br/>
        My name is Raymond Purnomo, I'm a fullstack web and mobile developer, and Linux Server Administrator.<br/>
        I'm currently in my final year in Computer Science degree.<br/>
        Created by <a href="/" target="_blank">Arcphysx</a><br/>
        To get started, type 'help' command or use sidebar on left
    `
}